export default __webpack_public_path__ + "static/mostafiz-uddin-266x266-721ce3353e160c0b3adceb829afb779b.jpeg";